const transferData = {
  uuid: 'ID',
  candidateName: 'Candidate name',
}

export default transferData
